module.exports = __webpack_public_path__ + "static/media/surper-1.1909161e.jpg";